import { render, staticRenderFns } from "./Catalog-registration.vue?vue&type=template&id=68a3ef34&scoped=true&"
var script = {}
import style0 from "./Catalog-registration.vue?vue&type=style&index=0&id=68a3ef34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a3ef34",
  null
  
)

export default component.exports